import React, { useEffect, useState } from 'react';
import './App.css';
import Header from './components/Header';
import HeroNew from './components/HeroNew';
import Problems from './components/Problems';
import Solution from './components/Solution';
import Differentiators from './components/Differentiators';
import Contact from './components/Contact';
import Blog from './components/Blog';
import { useAnalytics } from './hooks/useAnalytics';
import { trackPageView } from './firebase';
import { AuthProvider } from './contexts/AuthContext';

function AppContent() {
  // Activar tracking automático
  useAnalytics();
  const [currentPage, setCurrentPage] = useState('home');

  // Track inicial de la página
  useEffect(() => {
    trackPageView('Home', 'ExpertMind - Plataforma de IA Corporativa');
    console.log('Firebase Analytics tracking initialized');
  }, []);

  // Función para navegar entre páginas
  const navigateToPage = (page) => {
    setCurrentPage(page);
    if (page === 'blog') {
      trackPageView('Blog', 'ExpertMind - Blog');
    } else {
      trackPageView('Home', 'ExpertMind - Plataforma de IA Corporativa');
    }
  };

  // Detectar si estamos en una página de blog al cargar
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const postId = urlParams.get('post');
    // Si hay un parámetro de post, asegurarse de que estamos en la página de blog
    if (postId) {
      setCurrentPage('blog');
    }
  }, []);

  return (
    <div className="App">
      <Header currentPage={currentPage} onNavigate={navigateToPage} />
      <main>
        {currentPage === 'home' ? (
          <>
            <HeroNew onNavigate={navigateToPage} />
            <Problems />
            <Solution />
            <Differentiators />
            <Contact />
          </>
        ) : (
          <Blog onNavigate={navigateToPage} />
        )}
      </main>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
